const mutations = {

  auth_success(state, { user, token, defClub, usermenu }) {
    state.status = "success",
      state.token = token,
      state.user = user,
      state.defClub = defClub,
      state.usermenu = usermenu;
    state.loading = false;
  },

  auth_error(state) {
    state.status = "error";
    state.loading = false;
  },

  auth_request(state) {
    state.status = "loading";
    state.loading = true;
  },
  SET_PROFIL_DATA(state, { user, defClub, usermenu }) {
    state.user = user,
      state.defClub = defClub,
      state.usermenu = usermenu;
  },
  REGISTER_USER() {

  },
  is_loading(state, data) {
    state.loading = data;
  },

  SET_TOKEN(state, token) {
    state.token = token;
  },

  logout(state) {
    state.status = "",
      state.token = null,
      state.user = null,
      state.defClub = null,
      state.usermenu = null,
      state.loading = false;
  }
};

export default mutations;
